import { format, isValid, parse } from "date-fns";
import { range } from "lodash-es";
import { DATE_FORMAT_DISPLAY } from "shared/utils/DateUtils";

/**
 * Format a date in ISO-8601 format to a display date format.
 *
 * @param date Date object
 */
export const formatDateDisplay = (date: Date) =>
  format(date, DATE_FORMAT_DISPLAY);

export const formatDateDisplayIfValid = (date?: Date) =>
  date && isValid(date) ? formatDateDisplay(date) : "";

/**
 * Parse a date string in display format to a Date object.
 *
 * @param date Date string in display format
 */
export const parseDateDisplay = (date: string) =>
  parse(date, DATE_FORMAT_DISPLAY, new Date());

/**
 * Get a list of month names in the specific locale/notation.
 */
export const getMonthNameList = (
  locale = "en",
  notation: Intl.DateTimeFormatOptions["month"] = "long",
) =>
  range(12).map((monthIndex) =>
    Intl.DateTimeFormat(locale, {
      month: notation,
    }).format(new Date(0, monthIndex)),
  );
